export default "__VITE_ASSET__BiAAhEf7__"